/**
 * @generated SignedSource<<7b8c5e2d076250d2666a1db6480f4cc9>>
 * @relayHash 97d240ad7066053c97eaeea2364276ac
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 97d240ad7066053c97eaeea2364276ac

import { ConcreteRequest } from 'relay-runtime';
export type useLeadsOnDutySubscription$variables = Record<PropertyKey, never>;
export type useLeadsOnDutySubscription$data = {
  readonly leadsOnDutyChanged: {
    readonly medicalSupervisors: ReadonlyArray<{
      readonly firstName: string;
      readonly id: string;
      readonly lastName: string;
    }>;
    readonly operationsLeads: ReadonlyArray<{
      readonly firstName: string;
      readonly id: string;
      readonly lastName: string;
    }>;
  };
};
export type useLeadsOnDutySubscription = {
  response: useLeadsOnDutySubscription$data;
  variables: useLeadsOnDutySubscription$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "firstName",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "lastName",
    "storageKey": null
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "LeadsOnDuty",
    "kind": "LinkedField",
    "name": "leadsOnDutyChanged",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "MedgateEmployee",
        "kind": "LinkedField",
        "name": "medicalSupervisors",
        "plural": true,
        "selections": (v0/*:: as any*/),
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "MedgateEmployee",
        "kind": "LinkedField",
        "name": "operationsLeads",
        "plural": true,
        "selections": (v0/*:: as any*/),
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "useLeadsOnDutySubscription",
    "selections": (v1/*:: as any*/),
    "type": "Subscription",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "useLeadsOnDutySubscription",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "id": "97d240ad7066053c97eaeea2364276ac",
    "metadata": {},
    "name": "useLeadsOnDutySubscription",
    "operationKind": "subscription",
    "text": null
  }
};
})();

(node as any).hash = "2cc6f520c57bf47b56800e5ed9479a5c";

export default node;
